import { useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { prop } from 'ramda';
import { useAppSelector } from '@core/js/store/hooks';
import { isExternalUrl, redirect as redirectUrl, isDocumentsAndMediaUrl } from '@theme/js/utils/url.util';

import { formatPath, getStateWithPrevPath } from '@core/js/hooks/navigate/useNavigate/helpers';

export const useNavigate = ({
    replace = false,
    redirect = false,
    shouldReload = false /* Lugano changes */
} = {}) => {
    const history = useHistory();
    const { pathLang = '' } = useParams();
    const { useTrailingSlash } = useAppSelector(prop('seo'));

    return useCallback((path, state, {
        removeParams = [],
        preserveSearchParams = true,
        preserveHash = false
    } = {}) => {
        if (isExternalUrl(path) || isDocumentsAndMediaUrl(path) || redirect) {
            redirectUrl(path);

            return;
        }

        const { search, hash, pathname } = window.location;
        const location = formatPath(
            path,
            pathLang,
            preserveSearchParams ? search : {},
            preserveHash ? hash : '',
            removeParams,
            useTrailingSlash
        );
        const currentLocation = formatPath(pathname, pathLang, search, hash, [], useTrailingSlash);

        if (replace) {
            history.replace(location, state);
        } else if (location !== currentLocation) {
            history.push(location, getStateWithPrevPath(path, state));
        }

        /* Lugano changes */
        if (shouldReload) {
            history.go(0);
        }
        /* Lugano changes */
    }, [
        pathLang,
        replace,
        history,
        redirect,
        useTrailingSlash,
        shouldReload
    ]);
};

